var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('RModal',{ref:"modal",attrs:{"title":_vm.modalTitle,"full-size":"","no-footer":"","persistent":false,"loading":_vm.loadingEmail}},[(_vm.email)?_c('EmailBatchDisplay',{attrs:{"email":_vm.email}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }